import React, { useState } from 'react'
import { Dialog, Button, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
import AssignmentIcon from '@material-ui/icons/Assignment'
import WarningIcon from '@material-ui/icons/Warning'
import InfoIcon from '@material-ui/icons/Info'
import ScheduleIcon from '@material-ui/icons/Schedule'
import Rating from '@material-ui/lab/Rating'
import Image from 'material-ui-image'
import { ThumbDown, ThumbUp } from '@mui/icons-material';

import useStyles from './styles'

const MobilePlaceModal = ({ place, placeDetails, placeDataImageURL, setReviewData, setWriteReviewData, open, setModalOpen, setChildClicked, likes, likeQuestion, dislikes, dislikeQuestion }) => {
    const classes = useStyles()

    const [showHours, setShowHours] = useState(false)
    const [localLike, setLocalLike] = useState(0)
    const [localDislike, setLocalDislike] = useState(0)

    const questionCategory = "Pharmacy"
    const question = "Does this location sell syringes?"

    function handleClose() {
        setChildClicked(-1)
        setModalOpen(false)
    }

    function toggleHours() {
        setShowHours(!showHours)
    }

    function handleLike() {
        const newLikeState = !likes.includes(place.docId)

        // If the new like state is TRUE (meaning it's being toggled on because it was previously false)
        // AND the user has disliked this question already, then set dislike to FALSE before we set like to TRUE
        if(newLikeState && dislikes.includes(place.docId)) {
            place.questionCounterDownvote -= 1
            dislikeQuestion(place.docId, false)
        }

        // Set like state
        place.questionCounterUpvote += newLikeState ? 1 : -1
        likeQuestion(place.docId, newLikeState)
    }

    function handleDislike() {
        const newDislikeState = !dislikes.includes(place.docId)

        // If the new dislike state is TRUE (meaning it's being toggled on because it was previously false)
        // AND the user has liked this question already, then set like to FALSE before we set dislike to TRUE
        if(newDislikeState && likes.includes(place.docId)) {
            place.questionCounterUpvote -= 1
            likeQuestion(place.docId, false)
        }

        // Set dislike state
        place.questionCounterDownvote += newDislikeState ? 1 : -1
        dislikeQuestion(place.docId, newDislikeState)
    }

    return (
        <div>
        {place && (
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{place.name}</DialogTitle>
                <DialogContent>
                    {(placeDataImageURL != '' && placeDetails?.photos && placeDetails?.photos.length > 0) && (
                        <Image src={placeDataImageURL} aspectRatio={(placeDetails.photos[0].width / placeDetails.photos[0].height)} />
                    )}

                    {!place?.reviews && (
                        <div>
                            <Typography component="legend">No Reviews Yet</Typography>
                            <Rating name="read-only" value={0} readOnly />
                        </div>
                    )}

                    {place?.reviews && (
                        <div>
                            <Typography component="legend">User Reviews</Typography>
                            <Rating name="read-only" value={place.rating} precision={0.1} readOnly />
                            <br />
                            <Button size="small" color="primary" onClick={() => {
                                setReviewData(place.reviews)
                            }}>
                                Read Reviews
                            </Button>
                        </div>
                    )}

                    <Button size="small" color="primary" onClick={() => {
                        setWriteReviewData(place)
                    }}>
                        Write a Review
                    </Button>

                    {(place?.isUserCustomLocation && place.isUserCustomLocation) && (
                        <div className={classes.categoryTitle}>
                            <WarningIcon className={classes.categoryIconWarning} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                This location was added by a user.
                            </Typography>
                        </div>
                    )}

                    {(placeDetails?.opening_hours?.weekday_text) && (
                        <div>
                            <div className={classes.categoryTitle} onClick={() => toggleHours()}>
                                <ScheduleIcon className={classes.categoryIcon} />
                                <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                    {showHours ? "Hide Hours" : "Show Hours"}
                                </Typography>
                                {showHours ? (
                                    <ExpandLessIcon className={classes.categoryIcon} />
                                ) : (
                                    <ExpandMoreIcon className={classes.categoryIcon} />
                                )}
                            </div>
                            {showHours ? (
                                <div>
                                    {placeDetails.opening_hours.weekday_text.map((hours, i) => (
                                        <div className={classes.categoryTitle} key={i}>
                                            <ScheduleIcon className={classes.categoryIconWhite} />
                                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                                {hours}
                                            </Typography>
                                        </div>
                                        
                                    ))}
                                </div>
                            ) : (<div />)}
                        </div>
                    )}

                    {place?.insuranceInfo && (
                        <div className={classes.categoryTitle}>
                            <AssignmentIcon className={classes.categoryIcon} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                {place.insuranceInfo}
                            </Typography>
                        </div>
                    )}

                    {placeDetails?.formatted_phone_number && (
                        <div className={classes.categoryTitle}>
                            <PhoneIcon className={classes.categoryIcon} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                {placeDetails.formatted_phone_number}
                            </Typography>
                        </div>
                    )}

                    {place?.email && (
                        <div className={classes.categoryTitle}>
                            <EmailIcon className={classes.categoryIcon} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                {place.email}
                            </Typography>
                        </div>
                    )}

                    {placeDetails?.formatted_address && (
                        <div className={classes.categoryTitle}>
                            <LocationOnIcon className={classes.categoryIcon} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                {placeDetails.formatted_address}
                            </Typography>
                        </div>
                    )}

                    {place?.extraDetails && (
                        <div className={classes.categoryTitle}>
                            <InfoIcon className={classes.categoryIcon} />
                            <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                {place.extraDetails}
                            </Typography>
                        </div>
                    )}

                    {place?.category1 === questionCategory && (
                        <div>
                            <br />
                            <Typography className={classes.thumbsUpDownText}>
                                Does this location sell syringes?
                            </Typography>
                            <div className={classes.thumbsUpDown}>
                                <ThumbUp className={likes.includes(place.docId) ? classes.thumbsUpIconHighlight : classes.thumbsUpIcon} onClick={() => handleLike()} />
                                <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                    ({place?.questionCounterUpvote ? place.questionCounterUpvote : "0"})
                                </Typography>
                                
                                <ThumbDown className={dislikes.includes(place.docId) ? classes.thumbsUpIconHighlight : classes.thumbsUpIcon} onClick={() => handleDislike()} />
                                <Typography variant="subtitle2" color="textSecondary" className={classes.categoryTitleText}>
                                    ({place?.questionCounterDownvote ? place.questionCounterDownvote : "0"})
                                </Typography>
                            </div>
                        </div>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {placeDetails?.website && (
                        <Button onClick={() => window.open(placeDetails.website, '_blank')}>Website</Button>
                    )}
                    {placeDetails?.formatted_address && (
                        <Button onClick={() => {window.open("http://maps.google.com/?q=" + placeDetails.name + " " + placeDetails.formatted_address, "_blank")}}>
                            Open in Google Maps
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        )}
        
        </div>
    )
}

export default MobilePlaceModal